import { render } from "./BadgeCard.vue?vue&type=template&id=4ac04d76"
import script from "./BadgeCard.vue?vue&type=script&lang=js"
export * from "./BadgeCard.vue?vue&type=script&lang=js"
script.render = render

export default script